
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12210',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12210",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.466",
  "data-fetching-client": "static-1.9661",
  "foundations-components": "static-1.7913",
  "foundations-components-legacy": "static-1.938",
  "foundations-theming": "static-1.4408",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.81",
  "head-dlb": "static-1.4994",
  "hs-test-utils": "static-1.8004",
  "hub-http-shared-msw-handlers": "static-1.9939",
  "hubspot-dlb": "static-2.1845",
  "hubspot-url-utils": "static-1.4115",
  "HubStyleTokens": "static-2.11460",
  "I18n": "static-7.1622",
  "jasmine-runner": "static-1.6457",
  "marketplace-storefront-base": "static-1.12271",
  "quartz": "static-1.7019",
  "react-dlb": "static-1.78",
  "react-rhumb": "static-1.16658",
  "reactive-variable-buffer-atom": "static-1.2849",
  "reporting-testing-lib": "static-1.9434",
  "settings-ui-lib": "static-1.12510",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7110",
  "ui-addon-i18n": "static-1.11141",
  "ui-addon-react-router-dom": "static-1.9534",
  "unified-auth": "static-1.479",
  "unified-auth-core-lib": "static-1.761",
  "usage-tracker": "static-1-cwunder-improve-network-queue-resilience.2",
  "usage-tracker-core": "static-1-cwunder-improve-network-queue-resilience.2",
  "customer-data-property-utils": "static-1.8079",
  "hub-http": "static-1.6214",
  "integrations-lib": "static-1.16090",
  "marketplace-ui-common": "static-1.19679",
  "property-management-iframe": "static-1.13104",
  "quartz-config": "static-1.797",
  "quartz-core": "static-1.6238",
  "quartz-routing": "static-1.449",
  "quick-fetch": "static-1.3908",
  "react": "static-7.185",
  "rpc-client-utils": "static-1.4641",
  "ts-schema": "static-1.4072",
  "ui-universal-auth": "static-1.8965",
  "UIComponents": "static-3.8406",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.446",
  "hs-promise-rejection-tracking": "static-1.5566",
  "PortalIdParser": "static-2.397",
  "raven": "static-3.5907",
  "raven-hubspot": "static-1.6214",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9619",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3392",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3296",
  "quartz-webpack": "static-1.3243",
  "bend-plugin-quartz-routing": "static-1.97",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4182",
  "floating-ui": "static-1.55",
  "foundations-assets": "static-1.4855",
  "foundations-theming-specialty": "static-1.2124",
  "framer-motion": "static-1.71",
  "hs-story-utils": "static-1.9417",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.20",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5336",
  "react-virtualized": "static-2.98",
  "StyleGuideUI": "static-3.487",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1884",
  "ui-fonts": "static-1.722",
  "ui-images": "static-2.1151",
  "bend-plugin-foundations-theming": "static-1.2891",
  "foundations-theming-base": "static-1.3393",
  "stylex": "static-1.32",
  "HeadJS": "static-2.758",
  "hs-test-utils-bend-plugin": "static-1.3115",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4318",
  "ai-components-ui-library": "static-1.8923",
  "ai-rendering-library": "static-1.10123",
  "chirp-fetch": "static-1.1878",
  "connections-embed-lib": "static-1.970",
  "copilot-toolkit": "static-1.11106",
  "feedback-loader": "static-1.29277",
  "laboratory-lib": "static-3.7148",
  "marketplace-embed": "static-1.22053",
  "marketplace-ui-details": "static-1.9575",
  "marketplace-ui-reviews": "static-1.19635",
  "marketplace-ui-tracking": "static-1.13850",
  "sanitize-text": "static-1.8132",
  "ui-addon-video-player": "static-1.8693",
  "usage-tracker-multi": "static-1-cwunder-improve-network-queue-resilience.2",
  "usage-tracker-session-replay": "static-1-cwunder-improve-network-queue-resilience.2",
  "wootric-nps": "static-1.6968",
  "quartz-head": "static-1.684",
  "web-vitals": "static-1.4",
  "apollo-link-hub-http": "static-2.4640",
  "immer": "static-1.33",
  "immerable": "static-1.4145",
  "highcharts": "static-8.103",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2499",
  "reporting-data": "static-1.67501",
  "cssUtils": "static-1.788",
  "flux-actions": "static-1.337",
  "HubStyle": "static-2.11767",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10199",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10358",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1-cwunder-improve-network-queue-resilience.2",
  "icons": "static-2.646",
  "marketplace-ui-apps-core": "static-1.18212",
  "storybook-react": "static-1.32",
  "trellis-story-utils": "static-1.4507",
  "foundations-components-test-utils": "static-1.5396",
  "quartz-i18n": "static-1.694",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.204",
  "microsoft-drive-integration-lib": "static-1.323",
  "fsm": "static-1.3722",
  "customer-data-objects": "static-1.7657",
  "property-translator": "static-1.5390",
  "hs-locale-management": "static-1.73",
  "frontend-preferences-client": "static-1.7920",
  "hs-promise-utils": "static-1.5584",
  "hubspot-apollo-client": "static-1.4868",
  "integrations-error-boundary-lib": "static-1.13505",
  "integrations-tracking-lib": "static-1.5590",
  "native-integrations-shared-strings": "static-1.7773",
  "reselect": "static-2.16",
  "sanitize": "static-1.4467",
  "superstore": "static-1.4753",
  "ui-shepherd-react": "static-3.10151",
  "ai-settings-ui-library": "static-1.7869",
  "hub-http-janus": "static-1.831",
  "hubspotter-http": "static-1.4644",
  "immutable-less": "static-1.4645",
  "marketplace-ui-client-types": "static-1.17086",
  "nav-meta": "static-1.29634",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10239",
  "ui-addon-upgrades": "static-9.17968",
  "inbound-db-properties-service-client": "static-1.3838",
  "property-management-common": "static-1.5392",
  "ui-addon-iframeable": "static-1.9046",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.533",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.694",
  "quartz-test": "static-1.694",
  "quartz-tracking": "static-1.398",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.51",
  "bender-build-tools": "static-1.3186",
  "usage-tracker-anonymous": "static-1-cwunder-improve-network-queue-resilience.2",
  "usage-tracker-public": "static-1-cwunder-improve-network-queue-resilience.2",
  "amplitude-session-replay-browser": "static-1.59",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21242",
  "ContentUtils": "static-1.68325",
  "customer-data-objects-ui-components": "static-1.13016",
  "sassPrefix": "static-1.155",
  "avatar-components": "static-1.2489",
  "customer-data-filters-ui": "static-1.39722",
  "customer-data-reference-ui-components": "static-1.13152",
  "embedded-academy-lib": "static-1.14292",
  "ExportDialog": "static-6.10382",
  "highlight.js": "static-1.78",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41269",
  "reporting-snowflake": "static-1.56119",
  "reporting-ui-components": "static-2.64772",
  "reporting-visualizations": "static-1.59577",
  "ui-addon-teams": "static-1.21528",
  "magpie-lib": "static-1.5546",
  "navigation-components": "static-1.17997",
  "magpie-types": "static-1.5006",
  "simple-logging-lib": "static-1.3039",
  "ai-studio-lib": "static-1.11576",
  "app-governance-lib": "static-1.1506",
  "developer-experience-shared-components": "static-1.10500",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7987",
  "ui-product-approvals": "static-1.28108",
  "ui-tool-access": "static-1.10139",
  "usage-based-billing-components-lib": "static-1.8831",
  "inbound-db-meta-service-client": "static-1.3578",
  "persist-promise": "static-1.3688",
  "reference-resolvers": "static-1.8159",
  "ui-extensibility-client-types": "static-1.3919",
  "hubspot-apollo-cache": "static-1.327",
  "universal-page-editor-lib": "static-1.3004",
  "final-form": "static-1.69",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2744",
  "merchandise-lib": "static-1.263",
  "atom": "static-1.5061",
  "purchase-motions-components": "static-1.5862",
  "salesImages": "static-1.524",
  "batch-promise": "static-1.1531",
  "crm-component-utils": "static-1.39043",
  "crm-properties-common-lib": "static-1.5873",
  "customer-data-properties": "static-1.51503",
  "framework-data-schema-resolvers": "static-1.6874",
  "property-value-citations": "static-1.2117",
  "reference-resolvers-lite": "static-1.8084",
  "navigation-messaging": "static-1.7324",
  "hubspotter-http-shared-msw-handlers": "static-1.9937",
  "cms-field-types": "static-1.4801",
  "content-icons-ui": "static-1.2223",
  "customer-data-ui-utilities": "static-1.9817",
  "events-data-lib": "static-1.207",
  "conversations-skeleton-state": "static-1.7237",
  "crm-message-bus": "static-1.42958",
  "customer-data-filters-ui-msw-helpers": "static-1.22157",
  "FormUrlGenerator": "static-2.4708",
  "framework-builder-read-service-client": "static-1.3997",
  "framework-data-schema-quick-fetch": "static-1.6779",
  "multi-account-reference-resolvers": "static-1.970",
  "onboarding-tours": "static-1.16574",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13649",
  "academy-common-lib": "static-1.13752",
  "content-assistance-lib": "static-1.7736",
  "dashboard-lib": "static-1.81491",
  "file-manager-components": "static-1.23592",
  "getting-started-shared-tasks": "static-1.18464",
  "hubspot-prosemirror": "static-1.18212",
  "hubspot-prosemirror-plugins": "static-1.18204",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19813",
  "share-with-third-party-component-lib": "static-1.8694",
  "ui-addon-draggable": "static-3.4755",
  "ui-asset-management-lib": "static-1.11008",
  "ui-business-units-lib": "static-1.9040",
  "user-context": "static-1.5094",
  "growth-payments-core": "static-1.25346",
  "reporting-plugins": "static-1.10307",
  "reporting-reports": "static-1.67179",
  "idb-keyval": "static-1.43",
  "reactive-lib": "static-1.714",
  "nest": "static-1.216",
  "codemirror": "static-5.94",
  "react-codemirror": "static-1.10616",
  "framework-listing-lib": "static-2.28669",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30689",
  "apps-service-types": "static-1.3869",
  "oauth-service-types": "static-1.4239",
  "onboarding-scopes": "static-1.6452",
  "onboarding-tours-client": "static-1.4788",
  "platform-infra-nav-components": "static-1.7661",
  "subscription-experience-data-types": "static-1.14918",
  "crm-record-cards-service-types": "static-1.3589",
  "location-customization-utils-lib": "static-1.9221",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5865",
  "signup-constants": "static-1.18818",
  "signup-ui-url-generator": "static-2.8037",
  "trials-service-types": "static-1.3894",
  "card-properties-lib": "static-1.44150",
  "commerce-subscription-lib": "static-1.37080",
  "crm-actions": "static-1.6313",
  "crm-cards-sdk": "static-1.43553",
  "customer-data-properties-shared-msw-handlers": "static-1.9266",
  "customer-data-tracking": "static-1.6878",
  "hs-resources": "static-1.146",
  "pulse": "static-1.563",
  "calling-global-api": "static-1.64477",
  "calling-internal-common": "static-1.31292",
  "calling-lifecycle-internal": "static-1.65859",
  "calling-lifecycle-messages": "static-1.58153",
  "commerce-products-lib": "static-1.9505",
  "conditional-properties-service-client": "static-1.3789",
  "crm-links": "static-1.6278",
  "external-options-client-types": "static-1.4150",
  "google-libphonenumber": "static-1.37",
  "inbounddb-objects-service-types": "static-1.4215",
  "meetings-icalendar-utils-lib": "static-1.621",
  "multi-currency-client-types": "static-1.3683",
  "object-builder-ui-client": "static-1.48703",
  "pipeline-validation-client-types": "static-1.3957",
  "smart-property-lib": "static-1.6909",
  "tiered-pricing": "static-1.1184",
  "ui-addon-form-validation": "static-1.10983",
  "crm-pipelines-api-client-types": "static-1.4130",
  "react-dnd-compat": "static-1.4607",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.856",
  "growth-data-modal": "static-1.5413",
  "growth-onboarding-confetti": "static-1.3057",
  "growth-onboarding-next-action-utils": "static-1.1891",
  "onboarding-tours-utils": "static-1.640",
  "ui-shepherd-tracker": "static-1.7532",
  "academy-service-client": "static-1.3672",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39091",
  "FileManagerLib": "static-1.39232",
  "video-embed": "static-1.35722",
  "zustand": "static-1.74",
  "ui-coaching-tips": "static-1.28522",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11230",
  "video-data-lib": "static-1.34888",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23500",
  "ui-addon-emoji-picker": "static-1.9879",
  "EmailSignatureEditor": "static-1.24341",
  "viral-links-lib": "static-1.7052",
  "data-token-picker": "static-1.16390",
  "react-flip-move": "static-1.69",
  "nested-table": "static-1.217",
  "timezone-utils": "static-2.5234",
  "getting-started-shared-tasks-store": "static-1.17582",
  "ui-addon-opt": "static-4.8360",
  "campaign-roi-lib": "static-1.9073",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7316",
  "customer-data-views-management": "static-1.25424",
  "framework-data-table": "static-2.11886",
  "marketing-platform-lib": "static-1.6845",
  "nudge-client-utils": "static-1.2545",
  "nudge-custom-ui-functions": "static-1.1011",
  "app-users-service-client": "static-1.5588",
  "app-users-service-types": "static-1.4996",
  "mini-checkout-client": "static-1.26777",
  "onboarding-utils": "static-1.5343",
  "permissions-shared-i18n-strings-fe": "static-1.2045",
  "ui-coaching-tips-shared-config": "static-1.28507",
  "edison-service-client-types": "static-1.378",
  "crm_data": "static-4.91930",
  "customer-data-sidebar": "static-2.45981",
  "enrichment-properties-lib": "static-1.16027",
  "commerce-billing-lib": "static-1.19032",
  "commerce-shared-components-lib": "static-1.18510",
  "commerce-tools-ui-lib": "static-1.10338",
  "crm-fe-perf": "static-1.22893",
  "bend-plugin-pulse": "static-1.66",
  "directed-graph": "static-1.925",
  "event-emitter": "static-1.938",
  "fast-json-patch": "static-1.62",
  "calling-error-reporting": "static-1.31299",
  "shared-worker-versioning": "static-1.11027",
  "calling-usage-tracker": "static-1.6531",
  "voice-sms-access-library": "static-1.939",
  "commerce-permissions": "static-1.759",
  "products-iframe-lib": "static-1.7901",
  "products-ui-components-shared-msw-handlers": "static-1.10321",
  "data-agent-kit": "static-1.178",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10022",
  "policy-lib": "static-1.6770",
  "react-tinymce": "static-1.55209",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10085",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54335",
  "tinymce-plugins": "static-1.57449",
  "tinymce-themes": "static-1.56305",
  "onboarding-data-sync-lib": "static-1.1941",
  "growth-onboarding-next-action-components": "static-1.1919",
  "user-context-client": "static-1.4602",
  "audio-components": "static-1.5900",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36743",
  "urlinator": "static-1.4527",
  "video-components": "static-1.13233",
  "outpost": "static-1.4174",
  "growth-onboarding-feedback-components": "static-1.6571",
  "content-media-composition-data-lib": "static-1.12223",
  "content-media-compositions": "static-2.16230",
  "media-bridge-lib": "static-1.18908",
  "commerce-tours-lib": "static-1.6070",
  "growth-onboarding-reliability": "static-1.5072",
  "sales-checkout-service-client": "static-1.3631",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21657",
  "sales-email-signature-service-client": "static-1.3833",
  "ts-utils-lib": "static-1.163",
  "breeze-engine-lib": "static-1.589",
  "crm-export-dialog": "static-1.6287",
  "crm-index-associations-lib": "static-1.6431",
  "crm-view-components": "static-1.201",
  "react-beautiful-dnd": "static-1.13",
  "tanstack-virtual": "static-1.29",
  "nudge-custom-function-registry": "static-1.2302",
  "nudge-renderer-utils": "static-1.2621",
  "whisper-core-api": "static-1.6592",
  "InboxConnectUtils": "static-4.14779",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5487",
  "settings-content-modals": "static-1.46047",
  "crm_universal": "static-1.21989",
  "customer-data-email": "static-1.18016",
  "card-payment-highlight-lib": "static-1.37146",
  "card-subscription-highlight-lib": "static-1.39503",
  "commerce-contract-lib": "static-1.12004",
  "invoices-highlight-card-lib": "static-1.54697",
  "orders-highlight-card-lib": "static-1.21437",
  "products-highlight-card-lib": "static-1.17788",
  "quotes-highlight-card-lib": "static-1.71976",
  "crm-source-interpretation-lib": "static-1.5333",
  "utility-belt": "static-1.2526",
  "payments-enrollment-embed-lib": "static-1.22786",
  "stripe-embedded-components": "static-1.7485",
  "customer-data-rte": "static-1.32960",
  "cv-backend-services": "static-1.1552",
  "growth-onboarding-empty-states": "static-1.5700",
  "payments-post-enroll-local-storage-lib": "static-1.5098",
  "qrcode-generator": "static-1.68",
  "quotes-client-types": "static-1.38066",
  "calling-orchestration-schema": "static-1.35716",
  "sales-views-client-types": "static-1.4251",
  "hub-http-contrib": "static-1.3033",
  "interframe": "static-3.4750",
  "tinymce-data": "static-1.40420",
  "ui-addon-sales-email": "static-1.5202",
  "layout-dnd-components": "static-1.12427",
  "layout-dnd-utils": "static-1.11402",
  "ui-brand-identity-lib": "static-1.15236",
  "NamespacedHubStyle": "static-2.9051",
  "social-insights-client-types": "static-1.22062",
  "js-cookie": "static-1.18",
  "ably": "static-2.2",
  "crm-index-visualization-core": "static-1.4114",
  "checkout-sdk": "static-3.23620",
  "checkout-service-types": "static-1.3812",
  "company-details-components": "static-1.6189",
  "payment-method-components": "static-1.6902",
  "pricing-pages-ui-components": "static-1.13927",
  "quote-checkout-service-types": "static-1.3464",
  "upgrade-catalog-service-types": "static-1.3510",
  "access-control-lib": "static-1.10426",
  "EmailComponents": "static-1.54705",
  "EmailData": "static-1.53382",
  "redux-less": "static-2.9472",
  "sequences-lib": "static-1.8023",
  "ui-gdpr-components": "static-1.10339",
  "products-ui-components": "static-1.40023",
  "accounting-integrations-ui-components": "static-1.7048",
  "invoices-ui-lib": "static-1.54713",
  "commerce-products-api": "static-1.2268",
  "invoices-iframe-lib": "static-1.56771",
  "quotes-modal-lib": "static-1.102654",
  "quotes-ui-lib": "static-1.80697",
  "stripe-connect-js": "static-1.68",
  "draft-content-plugins": "static-1.28230",
  "ContentData": "static-1.68400",
  "layout-data-lib": "static-1.9727",
  "hub-http-rxjs": "static-1.797",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3929",
  "billing-payments-client-types": "static-1.3980",
  "react-performance-metrics-lib": "static-1.547",
  "account-and-billing-fintech-outages": "static-3.18572",
  "pricing-pages-api": "static-1.13792",
  "ContentComponents": "static-2.71281",
  "marketing-contacts-lib": "static-1.9992",
  "marketing-email-service-types": "static-1.1910",
  "messaging-editing-lib": "static-1.46238",
  "messaging-usage-based-billing-components-lib": "static-1.1100",
  "automation-ui-source-apps": "static-1.18852",
  "automation-ui-types": "static-1.19770",
  "messaging-types-lib": "static-1.45975",
  "onboarding-settings-client": "static-1.4495",
  "sequences-client-types-lib": "static-1.7880",
  "commerce-tax-lib": "static-1.517",
  "price-books-api": "static-1.636",
  "price-books-components": "static-1.694",
  "property-description-translator": "static-1.3835",
  "ramp-editor": "static-1.118",
  "commerce-analytics-service-client": "static-1.3619",
  "totals-ui-components": "static-1.23561",
  "SalesContentIndexUI": "static-3.9223",
  "advanced-menus-core": "static-1.15111",
  "advanced-menus-lib": "static-1.12054",
  "ui-memberships-settings-lib": "static-1.34015",
  "segments-query-core": "static-1.1410",
  "demographics-service-types": "static-1.1643",
  "eligibility-engine-service-types": "static-1.3175",
  "automation-ui-ubb": "static-1.5686",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7331",
  "data-token-views": "static-1.16371",
  "forms-utils-lib": "static-1.12558",
  "payments-embed-points-lib": "static-1.13006",
  "simple-menus-core": "static-1.15110",
  "simple-menus-lib": "static-1.16627",
  "ui-addon-draggable-compat": "static-2.4246",
  "videoconference-integration-components": "static-1.6803",
  "marketing-contacts-client": "static-1.7508",
  "automation-applications-service-types": "static-1.3498",
  "automation-platform-service-types": "static-1.2587",
  "ContentEditorUI": "static-2.77082",
  "short-messages-app-service-client": "static-1.3961",
  "web-interactives-components": "static-1.13743",
  "web-interactives-data": "static-1.13744",
  "messaging-shared-utils-lib": "static-1.549",
  "messaging-user-info-utils-lib": "static-1.719",
  "email-portal-health-service-types": "static-1.967",
  "line-items-api": "static-1.669",
  "commerce-totals-service-types": "static-1.3810",
  "FireAlarmUi": "static-1.4504",
  "sales-templates-service-types-lib": "static-1.4162",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21706",
  "automation-ui-usage-tracking": "static-1.21169",
  "data-studio-ubb": "static-1.2693",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26997",
  "collaboration-sidebar": "static-1.57772",
  "content-management-data-lib": "static-1.5372",
  "copilot-plugins": "static-1.11079",
  "cta-picker": "static-1.36368",
  "customer-agent-discovery-components-lib": "static-1.3049",
  "editor-components": "static-1.13214",
  "editor-iframe-lib": "static-1.8386",
  "error-messaging-js": "static-1.5183",
  "FormsCommonComponents": "static-1.85814",
  "pictos": "static-7.184",
  "react-transition-group": "static-2.64",
  "redux-request-state": "static-1.10637",
  "SharedLegalStrings": "static-1.1739",
  "smart-content-core": "static-1.42407",
  "smart-content-lib": "static-1.43060",
  "social-composer-lib": "static-1.59062",
  "structured-content-lib": "static-1.25157",
  "theme-previewer-lib": "static-1.53219",
  "tinymce-copilot": "static-1.16403",
  "xray-recommendation-lib": "static-1.7882",
  "automation-ui-routing": "static-1.21127",
  "sql-reporting-client-types": "static-1.5630",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42168",
  "campaigns-utils-lib": "static-1.3169",
  "reporting-enablement": "static-1.22882",
  "chatspot-widget-iframe": "static-1.21233",
  "collaboration-sidebar-common": "static-1.2569",
  "forms-ai-lib": "static-1.4304",
  "codemirror-dlb": "static-1.58641",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6422",
  "report-customization-components": "static-1.13127",
  "data-quality-ui-library": "static-1.12990",
  "html-to-image": "static-1.53",
  "reporting-filters": "static-1.294",
  "reporting-insights-lib": "static-1.1715"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12210",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.466",
  "data-fetching-client": "/data-fetching-client/static-1.9661",
  "foundations-components": "/foundations-components/static-1.7913",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.938",
  "foundations-theming": "/foundations-theming/static-1.4408",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.81",
  "head-dlb": "/head-dlb/static-1.4994",
  "hs-test-utils": "/hs-test-utils/static-1.8004",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9939",
  "hubspot-dlb": "/hubspot-dlb/static-2.1845",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
  "HubStyleTokens": "/HubStyleTokens/static-2.11460",
  "I18n": "/I18n/static-7.1622",
  "jasmine-runner": "/jasmine-runner/static-1.6457",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12271",
  "quartz": "/quartz/static-1.7019",
  "react-dlb": "/react-dlb/static-1.78",
  "react-rhumb": "/react-rhumb/static-1.16658",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2849",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9434",
  "settings-ui-lib": "/settings-ui-lib/static-1.12510",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7110",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11141",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9534",
  "unified-auth": "/unified-auth/static-1.479",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.761",
  "usage-tracker": "/usage-tracker/static-1-cwunder-improve-network-queue-resilience.2",
  "usage-tracker-core": "/usage-tracker-core/static-1-cwunder-improve-network-queue-resilience.2",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8079",
  "hub-http": "/hub-http/static-1.6214",
  "integrations-lib": "/integrations-lib/static-1.16090",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19679",
  "property-management-iframe": "/property-management-iframe/static-1.13104",
  "quartz-config": "/quartz-config/static-1.797",
  "quartz-core": "/quartz-core/static-1.6238",
  "quartz-routing": "/quartz-routing/static-1.449",
  "quick-fetch": "/quick-fetch/static-1.3908",
  "react": "/react/static-7.185",
  "rpc-client-utils": "/rpc-client-utils/static-1.4641",
  "ts-schema": "/ts-schema/static-1.4072",
  "ui-universal-auth": "/ui-universal-auth/static-1.8965",
  "UIComponents": "/UIComponents/static-3.8406",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.446",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "raven": "/raven/static-3.5907",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9619",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3392",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3296",
  "quartz-webpack": "/quartz-webpack/static-1.3243",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.97",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4182",
  "floating-ui": "/floating-ui/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4855",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2124",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-story-utils": "/hs-story-utils/static-1.9417",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.20",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5336",
  "react-virtualized": "/react-virtualized/static-2.98",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1884",
  "ui-fonts": "/ui-fonts/static-1.722",
  "ui-images": "/ui-images/static-2.1151",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2891",
  "foundations-theming-base": "/foundations-theming-base/static-1.3393",
  "stylex": "/stylex/static-1.32",
  "HeadJS": "/HeadJS/static-2.758",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3115",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4318",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8923",
  "ai-rendering-library": "/ai-rendering-library/static-1.10123",
  "chirp-fetch": "/chirp-fetch/static-1.1878",
  "connections-embed-lib": "/connections-embed-lib/static-1.970",
  "copilot-toolkit": "/copilot-toolkit/static-1.11106",
  "feedback-loader": "/feedback-loader/static-1.29277",
  "laboratory-lib": "/laboratory-lib/static-3.7148",
  "marketplace-embed": "/marketplace-embed/static-1.22053",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9575",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19635",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13850",
  "sanitize-text": "/sanitize-text/static-1.8132",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8693",
  "usage-tracker-multi": "/usage-tracker-multi/static-1-cwunder-improve-network-queue-resilience.2",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-cwunder-improve-network-queue-resilience.2",
  "wootric-nps": "/wootric-nps/static-1.6968",
  "quartz-head": "/quartz-head/static-1.684",
  "web-vitals": "/web-vitals/static-1.4",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4640",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4145",
  "highcharts": "/highcharts/static-8.103",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2499",
  "reporting-data": "/reporting-data/static-1.67501",
  "cssUtils": "/cssUtils/static-1.788",
  "flux-actions": "/flux-actions/static-1.337",
  "HubStyle": "/HubStyle/static-2.11767",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10199",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10358",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1-cwunder-improve-network-queue-resilience.2",
  "icons": "/icons/static-2.646",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18212",
  "storybook-react": "/storybook-react/static-1.32",
  "trellis-story-utils": "/trellis-story-utils/static-1.4507",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5396",
  "quartz-i18n": "/quartz-i18n/static-1.694",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.204",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.323",
  "fsm": "/fsm/static-1.3722",
  "customer-data-objects": "/customer-data-objects/static-1.7657",
  "property-translator": "/property-translator/static-1.5390",
  "hs-locale-management": "/hs-locale-management/static-1.73",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7920",
  "hs-promise-utils": "/hs-promise-utils/static-1.5584",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4868",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13505",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5590",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7773",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4467",
  "superstore": "/superstore/static-1.4753",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10151",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7869",
  "hub-http-janus": "/hub-http-janus/static-1.831",
  "hubspotter-http": "/hubspotter-http/static-1.4644",
  "immutable-less": "/immutable-less/static-1.4645",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17086",
  "nav-meta": "/nav-meta/static-1.29634",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10239",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17968",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3838",
  "property-management-common": "/property-management-common/static-1.5392",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9046",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.533",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.694",
  "quartz-test": "/quartz-test/static-1.694",
  "quartz-tracking": "/quartz-tracking/static-1.398",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.51",
  "bender-build-tools": "/bender-build-tools/static-1.3186",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1-cwunder-improve-network-queue-resilience.2",
  "usage-tracker-public": "/usage-tracker-public/static-1-cwunder-improve-network-queue-resilience.2",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21242",
  "ContentUtils": "/ContentUtils/static-1.68325",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13016",
  "sassPrefix": "/sassPrefix/static-1.155",
  "avatar-components": "/avatar-components/static-1.2489",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39722",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13152",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14292",
  "ExportDialog": "/ExportDialog/static-6.10382",
  "highlight.js": "/highlight.js/static-1.78",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41269",
  "reporting-snowflake": "/reporting-snowflake/static-1.56119",
  "reporting-ui-components": "/reporting-ui-components/static-2.64772",
  "reporting-visualizations": "/reporting-visualizations/static-1.59577",
  "ui-addon-teams": "/ui-addon-teams/static-1.21528",
  "magpie-lib": "/magpie-lib/static-1.5546",
  "navigation-components": "/navigation-components/static-1.17997",
  "magpie-types": "/magpie-types/static-1.5006",
  "simple-logging-lib": "/simple-logging-lib/static-1.3039",
  "ai-studio-lib": "/ai-studio-lib/static-1.11576",
  "app-governance-lib": "/app-governance-lib/static-1.1506",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10500",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7987",
  "ui-product-approvals": "/ui-product-approvals/static-1.28108",
  "ui-tool-access": "/ui-tool-access/static-1.10139",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8831",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3578",
  "persist-promise": "/persist-promise/static-1.3688",
  "reference-resolvers": "/reference-resolvers/static-1.8159",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3919",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.327",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3004",
  "final-form": "/final-form/static-1.69",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2744",
  "merchandise-lib": "/merchandise-lib/static-1.263",
  "atom": "/atom/static-1.5061",
  "purchase-motions-components": "/purchase-motions-components/static-1.5862",
  "salesImages": "/salesImages/static-1.524",
  "batch-promise": "/batch-promise/static-1.1531",
  "crm-component-utils": "/crm-component-utils/static-1.39043",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5873",
  "customer-data-properties": "/customer-data-properties/static-1.51503",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6874",
  "property-value-citations": "/property-value-citations/static-1.2117",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8084",
  "navigation-messaging": "/navigation-messaging/static-1.7324",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9937",
  "cms-field-types": "/cms-field-types/static-1.4801",
  "content-icons-ui": "/content-icons-ui/static-1.2223",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9817",
  "events-data-lib": "/events-data-lib/static-1.207",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7237",
  "crm-message-bus": "/crm-message-bus/static-1.42958",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22157",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4708",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3997",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6779",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.970",
  "onboarding-tours": "/onboarding-tours/static-1.16574",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13649",
  "academy-common-lib": "/academy-common-lib/static-1.13752",
  "content-assistance-lib": "/content-assistance-lib/static-1.7736",
  "dashboard-lib": "/dashboard-lib/static-1.81491",
  "file-manager-components": "/file-manager-components/static-1.23592",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18464",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18212",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18204",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19813",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8694",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4755",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11008",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9040",
  "user-context": "/user-context/static-1.5094",
  "growth-payments-core": "/growth-payments-core/static-1.25346",
  "reporting-plugins": "/reporting-plugins/static-1.10307",
  "reporting-reports": "/reporting-reports/static-1.67179",
  "idb-keyval": "/idb-keyval/static-1.43",
  "reactive-lib": "/reactive-lib/static-1.714",
  "nest": "/nest/static-1.216",
  "codemirror": "/codemirror/static-5.94",
  "react-codemirror": "/react-codemirror/static-1.10616",
  "framework-listing-lib": "/framework-listing-lib/static-2.28669",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30689",
  "apps-service-types": "/apps-service-types/static-1.3869",
  "oauth-service-types": "/oauth-service-types/static-1.4239",
  "onboarding-scopes": "/onboarding-scopes/static-1.6452",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4788",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7661",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14918",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3589",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9221",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5865",
  "signup-constants": "/signup-constants/static-1.18818",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8037",
  "trials-service-types": "/trials-service-types/static-1.3894",
  "card-properties-lib": "/card-properties-lib/static-1.44150",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37080",
  "crm-actions": "/crm-actions/static-1.6313",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43553",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9266",
  "customer-data-tracking": "/customer-data-tracking/static-1.6878",
  "hs-resources": "/hs-resources/static-1.146",
  "pulse": "/pulse/static-1.563",
  "calling-global-api": "/calling-global-api/static-1.64477",
  "calling-internal-common": "/calling-internal-common/static-1.31292",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65859",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58153",
  "commerce-products-lib": "/commerce-products-lib/static-1.9505",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3789",
  "crm-links": "/crm-links/static-1.6278",
  "external-options-client-types": "/external-options-client-types/static-1.4150",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4215",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.621",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3683",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48703",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3957",
  "smart-property-lib": "/smart-property-lib/static-1.6909",
  "tiered-pricing": "/tiered-pricing/static-1.1184",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10983",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4130",
  "react-dnd-compat": "/react-dnd-compat/static-1.4607",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.856",
  "growth-data-modal": "/growth-data-modal/static-1.5413",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3057",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1891",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.640",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7532",
  "academy-service-client": "/academy-service-client/static-1.3672",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39091",
  "FileManagerLib": "/FileManagerLib/static-1.39232",
  "video-embed": "/video-embed/static-1.35722",
  "zustand": "/zustand/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28522",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11230",
  "video-data-lib": "/video-data-lib/static-1.34888",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23500",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9879",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24341",
  "viral-links-lib": "/viral-links-lib/static-1.7052",
  "data-token-picker": "/data-token-picker/static-1.16390",
  "react-flip-move": "/react-flip-move/static-1.69",
  "nested-table": "/nested-table/static-1.217",
  "timezone-utils": "/timezone-utils/static-2.5234",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17582",
  "ui-addon-opt": "/ui-addon-opt/static-4.8360",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9073",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7316",
  "customer-data-views-management": "/customer-data-views-management/static-1.25424",
  "framework-data-table": "/framework-data-table/static-2.11886",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6845",
  "nudge-client-utils": "/nudge-client-utils/static-1.2545",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1011",
  "app-users-service-client": "/app-users-service-client/static-1.5588",
  "app-users-service-types": "/app-users-service-types/static-1.4996",
  "mini-checkout-client": "/mini-checkout-client/static-1.26777",
  "onboarding-utils": "/onboarding-utils/static-1.5343",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2045",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28507",
  "edison-service-client-types": "/edison-service-client-types/static-1.378",
  "crm_data": "/crm_data/static-4.91930",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45981",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16027",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19032",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18510",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10338",
  "crm-fe-perf": "/crm-fe-perf/static-1.22893",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.66",
  "directed-graph": "/directed-graph/static-1.925",
  "event-emitter": "/event-emitter/static-1.938",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "calling-error-reporting": "/calling-error-reporting/static-1.31299",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11027",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6531",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.939",
  "commerce-permissions": "/commerce-permissions/static-1.759",
  "products-iframe-lib": "/products-iframe-lib/static-1.7901",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10321",
  "data-agent-kit": "/data-agent-kit/static-1.178",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10022",
  "policy-lib": "/policy-lib/static-1.6770",
  "react-tinymce": "/react-tinymce/static-1.55209",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10085",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54335",
  "tinymce-plugins": "/tinymce-plugins/static-1.57449",
  "tinymce-themes": "/tinymce-themes/static-1.56305",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1941",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1919",
  "user-context-client": "/user-context-client/static-1.4602",
  "audio-components": "/audio-components/static-1.5900",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36743",
  "urlinator": "/urlinator/static-1.4527",
  "video-components": "/video-components/static-1.13233",
  "outpost": "/outpost/static-1.4174",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6571",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12223",
  "content-media-compositions": "/content-media-compositions/static-2.16230",
  "media-bridge-lib": "/media-bridge-lib/static-1.18908",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6070",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5072",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3631",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21657",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3833",
  "ts-utils-lib": "/ts-utils-lib/static-1.163",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.589",
  "crm-export-dialog": "/crm-export-dialog/static-1.6287",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6431",
  "crm-view-components": "/crm-view-components/static-1.201",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.29",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2302",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2621",
  "whisper-core-api": "/whisper-core-api/static-1.6592",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14779",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5487",
  "settings-content-modals": "/settings-content-modals/static-1.46047",
  "crm_universal": "/crm_universal/static-1.21989",
  "customer-data-email": "/customer-data-email/static-1.18016",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37146",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39503",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12004",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54697",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21437",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17788",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71976",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5333",
  "utility-belt": "/utility-belt/static-1.2526",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22786",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7485",
  "customer-data-rte": "/customer-data-rte/static-1.32960",
  "cv-backend-services": "/cv-backend-services/static-1.1552",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5700",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5098",
  "qrcode-generator": "/qrcode-generator/static-1.68",
  "quotes-client-types": "/quotes-client-types/static-1.38066",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35716",
  "sales-views-client-types": "/sales-views-client-types/static-1.4251",
  "hub-http-contrib": "/hub-http-contrib/static-1.3033",
  "interframe": "/interframe/static-3.4750",
  "tinymce-data": "/tinymce-data/static-1.40420",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5202",
  "layout-dnd-components": "/layout-dnd-components/static-1.12427",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11402",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15236",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9051",
  "social-insights-client-types": "/social-insights-client-types/static-1.22062",
  "js-cookie": "/js-cookie/static-1.18",
  "ably": "/ably/static-2.2",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4114",
  "checkout-sdk": "/checkout-sdk/static-3.23620",
  "checkout-service-types": "/checkout-service-types/static-1.3812",
  "company-details-components": "/company-details-components/static-1.6189",
  "payment-method-components": "/payment-method-components/static-1.6902",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13927",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3464",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3510",
  "access-control-lib": "/access-control-lib/static-1.10426",
  "EmailComponents": "/EmailComponents/static-1.54705",
  "EmailData": "/EmailData/static-1.53382",
  "redux-less": "/redux-less/static-2.9472",
  "sequences-lib": "/sequences-lib/static-1.8023",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10339",
  "products-ui-components": "/products-ui-components/static-1.40023",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7048",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54713",
  "commerce-products-api": "/commerce-products-api/static-1.2268",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56771",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102654",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80697",
  "stripe-connect-js": "/stripe-connect-js/static-1.68",
  "draft-content-plugins": "/draft-content-plugins/static-1.28230",
  "ContentData": "/ContentData/static-1.68400",
  "layout-data-lib": "/layout-data-lib/static-1.9727",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.797",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3929",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3980",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.547",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18572",
  "pricing-pages-api": "/pricing-pages-api/static-1.13792",
  "ContentComponents": "/ContentComponents/static-2.71281",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9992",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1910",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46238",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1100",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18852",
  "automation-ui-types": "/automation-ui-types/static-1.19770",
  "messaging-types-lib": "/messaging-types-lib/static-1.45975",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4495",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7880",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.517",
  "price-books-api": "/price-books-api/static-1.636",
  "price-books-components": "/price-books-components/static-1.694",
  "property-description-translator": "/property-description-translator/static-1.3835",
  "ramp-editor": "/ramp-editor/static-1.118",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3619",
  "totals-ui-components": "/totals-ui-components/static-1.23561",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9223",
  "advanced-menus-core": "/advanced-menus-core/static-1.15111",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12054",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34015",
  "segments-query-core": "/segments-query-core/static-1.1410",
  "demographics-service-types": "/demographics-service-types/static-1.1643",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3175",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5686",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7331",
  "data-token-views": "/data-token-views/static-1.16371",
  "forms-utils-lib": "/forms-utils-lib/static-1.12558",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13006",
  "simple-menus-core": "/simple-menus-core/static-1.15110",
  "simple-menus-lib": "/simple-menus-lib/static-1.16627",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4246",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6803",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7508",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3498",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2587",
  "ContentEditorUI": "/ContentEditorUI/static-2.77082",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3961",
  "web-interactives-components": "/web-interactives-components/static-1.13743",
  "web-interactives-data": "/web-interactives-data/static-1.13744",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.549",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.719",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.967",
  "line-items-api": "/line-items-api/static-1.669",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3810",
  "FireAlarmUi": "/FireAlarmUi/static-1.4504",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4162",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21706",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21169",
  "data-studio-ubb": "/data-studio-ubb/static-1.2693",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26997",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57772",
  "content-management-data-lib": "/content-management-data-lib/static-1.5372",
  "copilot-plugins": "/copilot-plugins/static-1.11079",
  "cta-picker": "/cta-picker/static-1.36368",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3049",
  "editor-components": "/editor-components/static-1.13214",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8386",
  "error-messaging-js": "/error-messaging-js/static-1.5183",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85814",
  "pictos": "/pictos/static-7.184",
  "react-transition-group": "/react-transition-group/static-2.64",
  "redux-request-state": "/redux-request-state/static-1.10637",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1739",
  "smart-content-core": "/smart-content-core/static-1.42407",
  "smart-content-lib": "/smart-content-lib/static-1.43060",
  "social-composer-lib": "/social-composer-lib/static-1.59062",
  "structured-content-lib": "/structured-content-lib/static-1.25157",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53219",
  "tinymce-copilot": "/tinymce-copilot/static-1.16403",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7882",
  "automation-ui-routing": "/automation-ui-routing/static-1.21127",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5630",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42168",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3169",
  "reporting-enablement": "/reporting-enablement/static-1.22882",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21233",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2569",
  "forms-ai-lib": "/forms-ai-lib/static-1.4304",
  "codemirror-dlb": "/codemirror-dlb/static-1.58641",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6422",
  "report-customization-components": "/report-customization-components/static-1.13127",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12990",
  "html-to-image": "/html-to-image/static-1.53",
  "reporting-filters": "/reporting-filters/static-1.294",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1715"
}
};
